const publicConfig = (<any>window)._config;

export const config = {
    apiUrl: process.env.NODE_ENV !== 'development' && publicConfig && publicConfig.apiUrl ? publicConfig.apiUrl + process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL,
    trackUrl: process.env.REACT_APP_TRACK_API,
    googleRecaptchaKeyId: publicConfig.googleRecaptchaKeyId || process.env.REACT_APP_RECAPTCHA_KEY_ID
};